export default __webpack_public_path__ + "static/media/naaLogo.b6c70560.svg";